import { useEffect, useState } from "react";
import { StyledComponent } from "styled-components";

type ProgressiveImageProps = {
  placeHolderSrc: string;
  src: string;
  alt: string;
  imageComponent: StyledComponent<"img", any, {}, never>;
};

function ProgressiveImage(props: ProgressiveImageProps) {
  const { placeHolderSrc, src, alt, imageComponent: Preview } = props;
  const [imgSrc, setImgSrc] = useState(placeHolderSrc || src);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      setImgSrc(src);
    };
  }, [src]);

  return <Preview src={imgSrc} alt={alt || ""} />;
}

export default ProgressiveImage;
